import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardTitle, Button, Row, Col, Alert, Spinner } from 'reactstrap';
import { useSede } from 'context/SedeContext';
import { useAuth } from 'context/AuthContext';
import { useNavigate } from 'react-router-dom';
import logo from 'assets/img/revive1.png';

const SedeSelection = () => {
  const { 
    availableSedes, 
    loading, 
    error, 
    selectGlobal, 
    selectAllSedes, 
    updateSelectedSedes,
    fetchAvailableSedes 
  } = useSede();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (availableSedes.length === 0 && !loading) {
      fetchAvailableSedes();
    }
  }, [availableSedes.length, loading, fetchAvailableSedes]);

  const handleGlobalSelection = async () => {
    setIsLoading(true);
    try {
      selectGlobal();
      // Pequeño delay para mostrar la selección
      await new Promise(resolve => setTimeout(resolve, 500));
      navigate('/admin/dashboard');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSedeSelection = async (sede) => {
    setIsLoading(true);
    try {
      updateSelectedSedes([sede]);
      // Pequeño delay para mostrar la selección
      await new Promise(resolve => setTimeout(resolve, 500));
      navigate('/admin/dashboard');
    } finally {
      setIsLoading(false);
    }
  };

  const handleAllSedesSelection = async () => {
    setIsLoading(true);
    try {
      selectAllSedes();
      // Pequeño delay para mostrar la selección
      await new Promise(resolve => setTimeout(resolve, 500));
      navigate('/admin/dashboard');
    } finally {
      setIsLoading(false);
    }
  };

  if (loading || isLoading) {
    return (
      <div className="content d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <Spinner color="primary" size="lg" />
          <p className="mt-3">Cargando sedes disponibles...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="content d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div className="container">
        <Row className="justify-content-center">
          <Col lg="8" md="10" sm="12">
            <Card className="shadow-lg">
              <CardBody className="text-center p-5">
                <img 
                  src={logo} 
                  alt="Revive Pilates" 
                  style={{ width: "150px", marginBottom: "2rem" }} 
                />
                
                <h3 className="mb-4">¡Hola, {user?.first_name || user?.username}!</h3>
                <p className="text-muted mb-4">
                  Selecciona la sede o modo de trabajo para continuar
                </p>

                {error && (
                  <Alert color="danger" className="mb-4">
                    {error}
                  </Alert>
                )}

                <div className="mb-4">
                  <Button
                    color="primary"
                    size="lg"
                    className="mb-3 w-100"
                    onClick={handleGlobalSelection}
                    disabled={isLoading}
                    style={{ 
                      backgroundColor: '#7F6552', 
                      borderColor: '#7F6552',
                      fontSize: '1.1rem',
                      padding: '1rem'
                    }}
                  >
                    🌐 Modo Global (Todas las sedes)
                  </Button>
                  <p className="text-muted small">
                    Ver datos de todas las sedes combinadas
                  </p>
                </div>

                {availableSedes.length > 0 && (
                  <>
                    <hr className="my-4" />
                    <h5 className="mb-3">Seleccionar sede específica:</h5>
                    
                    <div className="mb-3">
                      <Button
                        color="outline-primary"
                        size="lg"
                        className="mb-3 w-100"
                        onClick={handleAllSedesSelection}
                        disabled={isLoading}
                        style={{ 
                          fontSize: '1rem',
                          padding: '0.8rem'
                        }}
                      >
                        📍 Todas las sedes
                      </Button>
                    </div>

                    <Row>
                      {availableSedes.map((sede) => (
                        <Col key={sede.id} lg="6" md="6" sm="12" className="mb-3">
                          <Button
                            color="success"
                            size="lg"
                            className="w-100"
                            outline
                            onClick={() => handleSedeSelection(sede)}
                            disabled={isLoading}
                            style={{ 
                              fontSize: '1rem',
                              padding: '1rem',
                              height: 'auto',
                              whiteSpace: 'normal'
                            }}
                          >
                            📍 {sede.name}
                          </Button>
                        </Col>
                      ))}
                    </Row>
                  </>
                )}

                {availableSedes.length === 0 && !loading && !error && (
                  <Alert color="info">
                    No hay sedes disponibles. Contacta al administrador.
                  </Alert>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SedeSelection;
